import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type SnackbarType = 'success' | 'error' | 'info' | 'warning';
export type SnackbarPosition = 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';

export interface SnackbarData {
    message: string;
    type: SnackbarType;
    duration?: number;
    position?: SnackbarPosition;
}

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
    private snackbarSubject = new BehaviorSubject<SnackbarData | null>(null);
    public snackbar$ = this.snackbarSubject.asObservable();

    show(message: string, type: SnackbarType = 'info', duration: number = 5000, position: SnackbarPosition = 'top-center'): void {
        this.snackbarSubject.next({ message, type, duration, position });
    }

    showSuccess(message: string, duration: number = 5000, position: SnackbarPosition = 'top-center'): void {
        this.show(message, 'success', duration, position);
    }

    showError(message: string, duration: number = 5000, position: SnackbarPosition = 'top-center'): void {
        this.show(message, 'error', duration, position);
    }

    showInfo(message: string, duration: number = 5000, position: SnackbarPosition = 'top-center'): void {
        this.show(message, 'info', duration, position);
    }

    showWarning(message: string, duration: number = 5000, position: SnackbarPosition = 'top-center'): void {
        this.show(message, 'warning', duration, position);
    }

    hide(): void {
        this.snackbarSubject.next(null);
    }
}
